
// src/pages/admin/AdminLogin.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/admin.css'; // Import the admin styles

function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [remainingAttempts, setRemainingAttempts] = useState(null);
  const navigate = useNavigate();
  
  // Check if already logged in
  useEffect(() => {
    if (localStorage.getItem('adminToken')) {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      const response = await fetch('/api/admin/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      
      const data = await response.json();
      
      if (response.ok) {
        localStorage.setItem('adminToken', data.token);
        navigate('/admin/dashboard');
      } else {
        setError(data.message || 'Login failed. Please check your credentials.');
        
        // Handle lockout status
        if (response.status === 423) {
          setIsLocked(true);
        } else {
          setIsLocked(false);
        }
        
        // Set remaining attempts if provided
        if (data.remainingAttempts !== undefined) {
          setRemainingAttempts(data.remainingAttempts);
        }
      }
    } catch (err) {
      setError('Connection error. Please try again later.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="login-form-wrapper">
        <h1>Admin Panel</h1>
        <p className="login-subtitle">Enter your credentials to access the admin area</p>
        
        {error && (
          <div className={`error-message ${isLocked ? 'error-locked' : ''}`}>
            {error}
            {remainingAttempts !== null && remainingAttempts > 0 && (
              <div className="attempts-warning">
                ⚠️ {remainingAttempts} attempt{remainingAttempts !== 1 ? 's' : ''} remaining before account lockout
              </div>
            )}
          </div>
        )}
        
        <form onSubmit={handleLogin} className="admin-login-form">
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={loading || isLocked}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading || isLocked}
            />
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading || isLocked}
          >
            {loading ? 'Logging in...' : isLocked ? 'Account Locked' : 'Login'}
          </button>
        </form>
        
        <div className="back-to-site">
          <a href="/">← Back to web app</a>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;